// =============================
// Imports
// =============================

import { Component } from 'react';
import PropTypes from 'prop-types';

import { Container, CoversList, StyledCover, Title } from './styles';

// =============================
// Component
// =============================

class CoverSlider extends Component {
  static displayName = 'CoverSliderMobile';

  static propTypes = {
    /** Props used by styled component to override styles */
    className: PropTypes.string,
    /** Array of Cover item */
    covers: PropTypes.arrayOf(
      PropTypes.shape({
        /** Id of the player context */
        contextId: PropTypes.string,
        /** Name of the player context */
        contextName: PropTypes.string,
        description: PropTypes.string,
        key: PropTypes.string,
        linkProps: PropTypes.shape({
          route: PropTypes.string,
          nextAs: PropTypes.string,
        }),
        placeholderType: PropTypes.string,
        preText: PropTypes.string,
        src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        title: PropTypes.string,
        type: PropTypes.string,
        vynil: PropTypes.bool,
      }),
    ),
    /** next-routes Link component. */
    LinkComponent: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    /** Title of slider */
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    covers: [],
    LinkComponent: null,
  };

  render() {
    const { className, covers, LinkComponent, title } = this.props;

    return (
      <Container className={className}>
        <Title>{title}</Title>
        <CoversList>
          {covers.map((cover, i) => (
            <StyledCover
              contextId={cover.contextId}
              contextName={cover.contextName}
              description={cover.description}
              index={i}
              key={cover.key}
              lazyload={i >= 5}
              LinkComponent={LinkComponent}
              linkProps={cover.linkProps}
              placeholderType={cover.placeholderType}
              preText={cover.preText}
              src={cover.src}
              title={cover.title}
              alt={cover.title}
              type={cover.type}
              vynil={cover.vynil || false}
            />
          ))}
        </CoversList>
      </Container>
    );
  }
}

export default CoverSlider;
